import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Cascade-layer order statement — MUST be imported first (before App's eager CSS
// graph) so it precedes every layered rule in the emitted bundle (ADR 030 §5 step 0).
import './layers.css'
import App from './app/App'
import './index.css'
import './common/styles/nordic.css'
import './common/styles/atelier.css'
import './common/styles/swiss.css'
import { installChunkErrorHandler } from './lib/lazy-with-retry'
import { PostHogProvider } from '@posthog/react'

installChunkErrorHandler()

// Do NOT strip `/mod/<id>` from the URL on load: ADR 028 makes the URL the
// canonical seed for the open module, so a deep link / hard refresh must render
// that module's pane on first paint. Stripping it made MainLayout redirect to
// the remembered module instead.

// Analytics: PostHog product analytics, production web only.
// Session replay is intentionally DISABLED — the app renders users' real inboxes,
// calendars, and contacts; recording it would violate the privacy model (PDR 007).
const POSTHOG_TOKEN =
  import.meta.env.VITE_POSTHOG_PROJECT_TOKEN ?? 'phc_tuvYqqeanqufShRj2NAAcBEYXCwWVkww7Mp7DofcNcLQ'
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com'
const analyticsEnabled = import.meta.env.PROD

const tree = analyticsEnabled ? (
  <PostHogProvider
    apiKey={POSTHOG_TOKEN}
    options={{ api_host: POSTHOG_HOST, defaults: '2026-01-30', persistence: 'memory', disable_session_recording: true }}
  >
    <App />
  </PostHogProvider>
) : (
  <App />
)

createRoot(document.getElementById('root')!).render(<StrictMode>{tree}</StrictMode>)
